var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.review.title))]),_c('hr'),_c('MovieSheet',{attrs:{"review":_vm.review},on:{"submit":function($event){return _vm.saveReview()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }